import { render, staticRenderFns } from "./PostSaleList.vue?vue&type=template&id=72a5e6c7&scoped=true&"
import script from "./PostSaleList.vue?vue&type=script&lang=js&"
export * from "./PostSaleList.vue?vue&type=script&lang=js&"
import style0 from "./PostSaleList.vue?vue&type=style&index=0&id=72a5e6c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a5e6c7",
  null
  
)

export default component.exports